import axios from "axios";
import Cookies from "js-cookie";

// Attach the IANA timezone to every request so the API
// can align date-range queries with the caller's local clock.
axios.defaults.headers.common["X-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;

axios.interceptors.response.use(
  r => r,
  error => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      Cookies.remove("accessToken", { path: "/" });
      Cookies.remove("refreshToken", { path: "/" });
      // window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default axios;
